<section class="callback">
  <div class="callback-wrap">
    <div class="description">
      <h2 class="description-title">{{ 'VIDEO_VERIFICATION.WAITING' | translate }}</h2>
      <div class="description-info">
        <img alt="icon" class="description-icon" src="assets/img/video-schedule-icon.svg" />
        <div class="description-inner">
          <h4 [innerHTML]="'VIDEO_VERIFICATION.TIMES' | translate" class="description-inner-head"></h4>
          <p class="description-text">{{ 'VIDEO_VERIFICATION.DAYS' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="callback-img">
      <img alt="young-customer" src="assets/img/customer-mobile.svg" />
    </div>
  </div>
</section>
